module.exports = __webpack_public_path__ + "media/assets/icons/book-283b636914a1cba7c319b8b796b6b623.svg";